export const crypToadzContractAddress = process.env.REACT_APP_CRYPTOADZ_CONTRACT || '';
export const croakzContractAddress = process.env.REACT_APP_CROAKZ_CONTRACT || '';
export const mf3rsContractAddress = process.env.REACT_APP_MF3RS_CONTRACT || '';